// ABOUTME: Reads the complete AI credit total returned with a usage report page.
// ABOUTME: Keeps the report summary independent from the table pagination size.

export const getTotalCreditsUsed = (report: {
    totalCreditsUsed?: unknown;
}): number => {
    const totalCreditsUsed = Number(report?.totalCreditsUsed);
    return Number.isFinite(totalCreditsUsed) ? totalCreditsUsed : 0;
};
